// extracted by mini-css-extract-plugin
export default {"root":"probation-assessment-tab_root__5cJER"};